import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { sweetAlert } from "../../components/Alert/sweetAlert";

//material ui components
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton';
import { ChevronList } from '../../utils/engageComponents';

//Icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import {
    AddMessage,
    AddMessageFilter
} from '../../actions/deviceActions';

//3 party Libs
import moment from 'moment';

class LModalReboot extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            fixedOptionSelected: undefined,
            disabledBackIcon: true,
            disabledFowardIcon: false,
            stepCounter: 0,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    async onSubmitHandler(formData) {

        const newMessage = {}
        newMessage.notificationType = "Reboot";
        newMessage.messageType = this.state.fixedOptionSelected === 1 ? "Normal" : "Reminder";
        newMessage.title = "";
        newMessage.message = "";
        newMessage.topics = [];
        newMessage.fullNotificationIconUrl = "";
        newMessage.translations = [];

        const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };

        if (this.props.selectAllButton) {
            newMessage.topics.push(``);
        } else {
            this.props.selectedDevices.forEach(selected => {
                newMessage.topics.push(`${selected.residentId}/${selected._id}`);
            });
        }

        const now = moment(new Date()).startOf('minute');
        let messageDate = moment(new Date());
        let messageEnd;

        if (this.state.scheduleDay && this.state.hourSelected && this.state.minuteSelected && this.state.dayTime) {
            messageDate = moment(this.state.scheduleDay.format('MM-DD-YYYY') + ' ' + this.state.hourSelected.number + ':' + this.state.minuteSelected.number + ' ' + this.state.dayTime.text, 'MM-DD-YYYY hh:mm A');
            messageEnd = this.state.notificationMessage ? moment(messageDate).add(this.state.messageModalSeconds, 'm') : moment(messageDate).add(this.state.messageModalHours, 'h')
        }

        if (messageDate < now) {
            let nowHour = now.hour() > 12 ? now.hour() - 12 : now.hour();
            let nowMinute = now.minutes();
            let nowDayTime = now.hour() > 11 ? 'PM' : 'AM';
            let nowDay = now.clone().startOf('day');

            let hourObject = {
                number: undefined,
                text: '',
            }

            let minuteObject = {
                number: undefined,
                text: '',
            }

            const datTimeObject = {
                text: nowDayTime,
            }
            if (nowHour === undefined) {
                hourObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                hourObject = {
                    number: nowHour,
                    text: ('0' + nowHour).slice(-2),
                }
            }

            if (nowMinute === undefined) {
                minuteObject = {
                    number: undefined,
                    text: '',
                }
            } else {

                minuteObject = {
                    number: nowMinute,
                    text: ('0' + nowMinute).slice(-2),
                }
            }
            this.setState({
                hourSelected: hourObject,
                minuteSelected: minuteObject,
                dayTime: datTimeObject,
                scheduleDay: nowDay,
            });

            const message = `Cannot select a time in the past`
            sweetAlert('error', message, 'alert_AddEditActivity_PastTime_Error', stylesObj);

            return;
        }

        if (this.state.messageEs !== '') {
            const spanishObj = {
                languageCode: 'es',
                title: this.state.titleEs,
                message: this.state.messageEs,
            }

            newMessage.translations.push(spanishObj);
        }

        if (this.state.messageFr !== '') {
            const frenchObj = {
                languageCode: 'fr',
                title: this.state.titleFr,
                message: this.state.messageFr,
            }

            newMessage.translations.push(frenchObj);
        }

        newMessage.messageDate = new Date(messageDate);
        newMessage.messageEnd = new Date(messageEnd);

        if (this.props.selectAllButton)
            this.props.AddMessageFilter(localStorage.getItem('communityId'), this.props.filterObj, newMessage, this.props.sortColumn, this.props.sortDesc, stylesObj);
        else
            this.props.AddMessage(newMessage, localStorage.getItem('communityId'), stylesObj);

    };

    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperLModalReboot" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justify='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justify='center' alignItems='center'>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '60px' }} justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10}>
                    <Grid item container direction='row-reverse'>
                        <Grid item container className="VoiceSettingModalButtonYes skybluebtn-engage alingCenter">
                            <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                Update
                            </Grid>
                        </Grid>
                        <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                Cancel
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    //#region Modal
    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: '35%',
            height: '50%',
            position: 'absolute',
            top: '20%',
            left: '35%'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '60%'
        },
        buttonsModal: {
            height: '40%',
            justify: 'center',
            marginTop: '20px',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginTop: '10px',
            marginLeft: '10px',
            width: '156px'
        },
        visibleDisabledButton: {
            marginTop: '10px',
            marginLeft: '10px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd',
            width: '7rem'
        }
    }

    //#endregion Modal

    RenderMessageContainer = () => {

        const week = [0, 1, 2, 3, 4, 5, 6];

        const RenderModalDayComponent = ({ daysToAdd }) => {

            let day = "";
            if (this.state.stepCounter === 0)
                day = moment(new Date()).add(daysToAdd, 'days');
            else
                day = moment(new Date()).add(daysToAdd + 7, 'days');

            const today = moment(new Date());
            const scheduleDay = this.state.scheduleDay ? this.state.scheduleDay : undefined;
            const sameDay = day.format('yyyy/MM/DD') === today.format('yyyy/MM/DD') ? true : false;
            const isScheduleDay = scheduleDay ? scheduleDay.format('yyyy/MM/DD') === day.format('yyyy/MM/DD') : false;

            return (
                <Grid item className={day < today ? "LscheduleModalDisabledCell" : "LscheduleModalCell"} onClick={() => this.handleDayClick(day, today)}>
                    <Grid item className="LdayTitle">{day.format('ddd').toUpperCase()}</Grid>
                    <Grid item className={isScheduleDay ? "LscheduleModalDate LscheduleModalScheduleDay" : sameDay ? "LscheduleModalDate LscheduleModalToday" : "LscheduleModalDate"}>{day.format('D')}</Grid>
                </Grid>
            );
        };

        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10} className="VoiceSubTitleModal">
                    <Grid container xs={12} justify='center' alignItems='center'>
                        <Grid container style={{ width: '85%', height: '100%' }}>
                            <Grid container justify='center' alignItems='space-between' style={{ height: '490px' }} >
                                <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                    {/* fixed options */}
                                    <Grid item container xs={12} justify='center' alignItems='center'>
                                        <Grid id='device_rebootmodal_nowscheduleOption' item className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 1) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()), 1)}>Now</Grid>
                                        {
                                            moment(new Date()).hour() < 12 ?
                                                <Grid id='device_rebootmodal_noontodayscheduleOption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 2) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).startOf('day').add(12, 'hours'), 2)}>Noon Today</Grid>
                                                :
                                                undefined
                                        }
                                        {
                                            moment(new Date()).day() !== 6 ?
                                                <Grid id='device_rebootmodal_noontomorrowscheduleOption' className={(this.state.fixedOptionSelected && this.state.fixedOptionSelected === 3) ? "ScheduleModalFixedOptionSelected" : "ScheduleModalFixedOption"} onClick={() => this.SelectOptionForMessage(moment(new Date()).add(1, 'days').startOf('day').add(12, 'hours'), 3)}>Noon Tomorrow</Grid>
                                                :
                                                undefined
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container xs={12} alignItems='center' justify='center' className="LcontentModal">
                                    <Grid item container xs={1} justify='center' alignItems='center'>
                                        <IconButton aria-label="leftArrow" onClick={() => this.AddStep(-1)} disabled={this.state.disabledBackIcon}>
                                            <ArrowBackIosIcon id='device_rebootmodal_arrowbackward' style={{ fontSize: 40, color: (this.state.disabledBackIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item container xs={10} justify='center' alignItems='center'>
                                        {
                                            week ? week.map(
                                                day => {
                                                    return (
                                                        <RenderModalDayComponent key={'DayComponent' + day} daysToAdd={day} />
                                                    );
                                                }
                                            ) :
                                                undefined
                                        }
                                    </Grid>
                                    <Grid item container xs={1} justify='center' alignItems='center'>
                                        <IconButton aria-label="RightArrow" onClick={() => this.AddStep(1)} disabled={this.state.disabledFowardIcon}>
                                            <ArrowForwardIosIcon id='device_rebootmodal_arrowforward' color='secondary' style={{ fontSize: 40, color: (this.state.disabledFowardIcon === false) ? '#f0efef' : '#1f1f1f' }} />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={12} justify='center' alignItems='center' className="contentModalNoOpacity">
                                    {/* Time Selection */}
                                    <Grid item container xs={9} justify='space-between' className="scheduleModalTimeListDevices">
                                        <Grid item container xs={4}>
                                            <ChevronList
                                                idToSet='device_rebootmodal_chevronlisthr'
                                                onArrowClick={this.onArrowClick}
                                                optionSelected={this.state.hourSelected}
                                                onChangeHandler={this.onChangeHandler}
                                                textClass="LChevronListText"
                                                placeHolder='hr'
                                            />
                                        </Grid>
                                        <Grid item xs={1} className="LmodalColon">:</Grid>
                                        <Grid item xs={4}>
                                            <ChevronList
                                                idToSet='device_rebootmodal_chevronlistmin'
                                                onArrowClick={this.onArrowClick}
                                                optionSelected={this.state.minuteSelected}
                                                onChangeHandler={this.onChangeHandler}
                                                textClass="LChevronListText"
                                                placeHolder='min'
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <ChevronList
                                                idToSet='device_rebootmodal_chevronlistdaytime'
                                                onArrowClick={this.onArrowClick}
                                                optionSelected={this.state.dayTime}
                                                onChangeHandler={this.onChangeHandler}
                                                textClass="LChevronListText"
                                                placeHolder='AM'
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <>
                <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/Solidblack/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
                </Grid>
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="LMultipleDeleteModalTitle">
                        <Grid>Schedule Reboot</Grid>
                    </Grid>
                </Grid>
            </>
        );
    }
    //#endregion

    AddStep = (step) => {

        let newValue = this.state.stepCounter + step;
        this.setState({ stepCounter: newValue });

        if (newValue === 1)
            this.setState({ disabledBackIcon: false, disabledFowardIcon: true });
        else
            this.setState({ disabledBackIcon: true, disabledFowardIcon: false });
    }

    onChangeHandler = (e, placeholder) => {

        let timeValue = e.target.value.slice(-2)

        if (placeholder === 'hr') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 12)) {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = 0;

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            } else {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                let hour = Number(e.target.value);

                hourObject.number = hour;
                hourObject.text = ('0' + hour).slice(-2);

                this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'min') {
            if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = 0;

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            } else {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                let minute = Number(e.target.value.slice(-2));

                minuteObject.number = minute
                minuteObject.text = ('0' + minute).slice(-2);

                this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
            }
        }

        if (placeholder === 'AM') {
            if (!(e.target.value === 'AM' || e.target.value === 'PM')) {
                this.setState({ dayTime: { text: 'AM' }, fixedOptionSelected: undefined });
            }
        }

    }

    onArrowClick = (order, placeHolder) => {

        if (placeHolder === 'hr') {
            let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
            let hour = hourObject.number ? hourObject.number : 0;

            if (order === 'Up') {

                if ((hour + 1) < 13) {
                    hour = hour + 1;
                }
            }
            else {
                if ((hour - 1) > 0) {
                    hour = hour - 1;
                }
            }

            hourObject.number = hour;
            hourObject.text = ('0' + hour).slice(-2);

            this.setState({ hourSelected: hourObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'min') {
            let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
            let minute = minuteObject.number ? minuteObject.number : 0;
            if (order === 'Up') {

                if ((minute + 1) < 60) {
                    minute = minute + 1;
                }
            }
            else {
                if ((minute - 1) > -1) {
                    minute = minute - 1;
                }
            }

            minuteObject.number = minute;
            minuteObject.text = ('0' + minute).slice(-2)

            this.setState({ minuteSelected: minuteObject, fixedOptionSelected: undefined });
        }

        if (placeHolder === 'AM') {
            let dayTime = 'AM';
            if (this.state.dayTime === undefined || this.state.dayTime.text === 'PM') {
                dayTime = 'AM';
            }
            else {
                dayTime = 'PM';
            }

            this.setState({ dayTime: { text: dayTime }, fixedOptionSelected: undefined });
        }
    }

    SelectOptionForMessage = (scheduleDate, option) => {

        let hour = scheduleDate.hour() > 12 ? scheduleDate.hour() - 12 : scheduleDate.hour();
        let minute = scheduleDate.minutes();
        let dayTime = scheduleDate.hour() > 11 ? 'PM' : 'AM';
        let daySelected = scheduleDate.clone().startOf('day');

        if (this.state.fixedOptionSelected && this.state.fixedOptionSelected === option) {
            option = undefined;
            hour = undefined;
            minute = undefined;
            dayTime = undefined;
            daySelected = undefined;
        };

        let hourObject = {
            number: undefined,
            text: '',
        }

        let minuteObject = {
            number: undefined,
            text: '',
        }

        const datTimeObject = {
            text: dayTime,
        }


        if (hour === undefined) {
            hourObject = {
                number: undefined,
                text: '',
            }
        } else {

            hourObject = {
                number: hour,
                text: ('0' + hour).slice(-2),
            }
        }

        if (minute === undefined) {
            minuteObject = {
                number: undefined,
                text: '',
            }
        } else {

            minuteObject = {
                number: minute,
                text: ('0' + minute).slice(-2),
            }
        }


        this.setState({
            fixedOptionSelected: option,
            hourSelected: hourObject,
            minuteSelected: minuteObject,
            dayTime: datTimeObject,
            scheduleDay: daySelected,
        });

    }

    handleDayClick = (day, today) => {

        if (day >= today) { this.setState({ scheduleDay: day }) }

        if (this.state.fixedOptionSelected !== undefined) {

            setTimeout(() => {

                const daySelected = moment(this.state.scheduleDay).format('DDDD');
                const todayD = moment(today).format('DDDD');
                const Tomorrow = moment(today).add(1, 'day').format('DDDD');

                if ((this.state.fixedOptionSelected === 1 || this.state.fixedOptionSelected === 2) && daySelected !== todayD) {

                    this.setState({ fixedOptionSelected: undefined });

                }
                else if (this.state.fixedOptionSelected === 3 && daySelected !== Tomorrow) {

                    this.setState({ fixedOptionSelected: undefined });

                }
            }, 300);
        }
    }

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


LModalReboot = reduxForm({
    form: 'LModalRebootForm',
    enableReinitialize: true,
})(LModalReboot);

export default connect(mapStateToProps, { AddMessage, AddMessageFilter })(LModalReboot);

